<template>
  <BaseDialogBox v-bind="$attrs">
    <v-card
      :min-width="maxWidth ? '' : 360"
      :max-width="$attrs['max-width'] ? ($attrs['max-width'] as string | number) : 480"
    >
      <v-card-title id="dialog-title" class="pt-7 pb-3 px-5">
        <h4 class="heading-3 bold black--text" :style="{ '-webkit-line-clamp': 2 }">
          <slot name="confirmation-title">
            {{ CONSTANTS.DEFAULT_CONFIRMATION_TITLE }}
          </slot>
        </h4>
      </v-card-title>
      <v-card-subtitle class="body-1 mt-0 mb-4 px-5 py-0 black--text">
        <slot name="confirmation-message">
          {{ CONSTANTS.DEFAULT_CONFIRMATION_MESSAGE }}
        </slot>
      </v-card-subtitle>
      <hr v-if="$slots['confirmation-actions']" class="separator" />
      <v-card-actions class="card-actions d-flex pb-4 px-4">
        <slot name="confirmation-actions">
          <BaseButton
            outlined
            plain
            height="40"
            class="bg-slate_100 cancel body-1 px-6 ml-auto"
            @click="() => $emit('cancel')"
          >
            {{ CONSTANTS.CANCEL }}
          </BaseButton>
          <BaseButton
            outlined
            plain
            height="40"
            class="text-white bg-emerald_600 confirm body-1 px-6"
            @click="() => $emit('confirm')"
          >
            {{ $attrs['confirmation-button-text'] ?? CONSTANTS.CONFIRM }}
          </BaseButton>
        </slot>
      </v-card-actions>
    </v-card>
  </BaseDialogBox>
</template>
<script setup lang="ts">
import CONSTANTS from '@/utils/constants/string-constants'
import { BaseDialogBox, BaseButton } from '../base'

defineProps<{
  maxWidth?: string | number
}>()
</script>
<style scoped lang="scss">
#dialog-title.v-card-title {
  white-space: normal !important;
}
</style>
